import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('reportSubscriptionsRouting', []).config([
  '$stateProvider',
  ($stateProvider) => {
    $stateProvider.state('reportSubscriptions-view', {
      parent: 'arw',
      url: '/report-subscriptions',
      template: `<report-subscriptions-page></report-subscriptions-page>`,
      params: {
        retailerId: null,
        retailerNumber: null,
        retailerType: null,
        pageTitle: [
          '$ngRedux',
          'gettextCatalog',
          ($ngRedux, gettextCatalog) => {
            $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Subscriptions')));
          },
        ],
      },
      redirectTo: 'permissions-denied',
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/report-subscriptions-routing-module.js